import config from "../config";

export const isProduction = config.env === "production";
